import { MessageBox } from 'element-ui'
function generateUUID () {
  return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

function getDataType (data) {
  return Object.prototype.toString.call(data).slice(8, -1).toLowerCase()
}

function isEmpty (value) {
  return value === undefined || value === null || (typeof value === 'string' && value.trim() === '')
}

function messageBoxConfirm ({
  title,
  message,
  type,
  confirmButtonText,
  cancelButtonText
}) {
  return new Promise((resolve, reject) => {
    MessageBox.confirm(
      message,
      title || '提示',
      {
        confirmButtonText: confirmButtonText || '确认',
        cancelButtonText: cancelButtonText || '取消',
        type: type || 'warning'
      }
    )
      .then(() => {
        resolve(true)
      })
      .catch(() => {
        resolve(false)
        console.log('取消')
      })
  })
}

function messageBoxAlert ({
  title,
  message,
  type,
  confirmButtonText
}) {
  return new Promise((resolve, reject) => {
    MessageBox.alert(
      message,
      title || '提示',
      {
        type: type || 'warning',
        confirmButtonText: confirmButtonText || '确认'
      }
    )
      .then(() => {
        resolve(true)
      })
      .catch(() => {
        resolve(false)
        console.log('取消')
      })
  })
}

export default {
  isEmpty,
  generateUUID,
  getDataType,
  messageBoxConfirm,
  messageBoxAlert
}
